import * as Firestore from '../../helpers/firestore'

import { useStore } from '../state'
import { useOnMount } from '../use-on-mount'

// `enabled` vaut false pour les comptes « client » : ces documents Firestore
// sont réservés aux administrateurs et ne servent qu'à l'écran Contenu.
export function useDatasourceDynamicContent(enabled: boolean = true) {
  const Store = useStore()

  // Keep references to the content documents
  const dynamicContent = Firestore.useCollectionReference('dynamic-content')

  // On mount, load dynamic content and sync to store
  useOnMount(() => {
    if (!enabled) {
      return
    }

    return dynamicContent.doc('legalNotices').onSnapshot((doc) => {
      const legalNotices = doc?.data()

      if (legalNotices) {
        Store.getActions().dynamicContent.setLegalNotices(legalNotices as any)
      } else {
        Store.getActions().dynamicContent.setLegalNotices(null)
      }
    })
  })
  useOnMount(() => {
    if (!enabled) {
      return
    }

    return dynamicContent.doc('privacyPolicy').onSnapshot((doc) => {
      const privacyPolicy = doc?.data()

      if (privacyPolicy) {
        Store.getActions().dynamicContent.setPrivacyPolicy(privacyPolicy as any)
      } else {
        Store.getActions().dynamicContent.setPrivacyPolicy(null)
      }
    })
  })
  useOnMount(() => {
    if (!enabled) {
      return
    }

    return dynamicContent.doc('faq').onSnapshot((doc) => {
      const faq = doc?.data()

      if (faq) {
        Store.getActions().dynamicContent.setFaq(faq as any)
      } else {
        Store.getActions().dynamicContent.setFaq(null)
      }
    })
  })
}
